function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable comma-spacing */
/* eslint-disable react/no-multi-comp */
import React, { useContext } from 'react';
import {
  useLocation,
  useMatches,
  useNavigate,
  useOutlet,
  useParams,
  useSearchParams } from
'react-router-dom';
import { AppMainContext } from "./App/AppMainContext";
import { searchParamsFromSearchParams } from "./utils/routeHelpers";

const withRouter =
(Component) =>
(props) => {var _props$params;
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const matches = useMatches();
  const [searchParams, setSearchParams] = useSearchParams();
  const { q: searchString } = searchParamsFromSearchParams(searchParams);
  const paramsFromProps = _objectSpread(_objectSpread({}, props.params), {}, { q: searchString || ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.q) });

  return (/*#__PURE__*/
    React.createElement(Component, _extends({},
    props, {
      navigate: navigate,
      location: location,
      params: _objectSpread(_objectSpread({}, params), paramsFromProps || {}),
      matches: matches,
      searchParams: searchParams,
      setSearchParams: setSearchParams })
    ));

};

const withContext =
(Component) =>
(props) => {
  const mainContext = useContext(AppMainContext);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, { mainContext: mainContext }));
};

const withOutlet =
(Component) =>
(props) => {
  const outlet = useOutlet(AppMainContext);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, { outlet: outlet }));
};

export { withRouter, withContext, withOutlet };